import React, { useState } from "react";
import { DefaultButton, MessageBar, MessageBarType } from "@fluentui/react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../lib/authConfig";

interface SignInButtonProps {
    onSuccess?: () => void;
    disabled?: boolean;
}

export const SignInButton: React.FC<SignInButtonProps> = ({ onSuccess, disabled = false }) => {
    const { instance } = useMsal();
    const [error, setError] = useState<string | null>(null);
    const handleSignIn = (): void => {
        if (disabled) return;

        instance.loginPopup(loginRequest)
            .then(() => {
                // Call onSuccess after successful login if provided
                if (onSuccess) {
                    onSuccess();
                }
            })
            .catch((e) => {
                console.error(e);
                setError("An error occurred during sign-in. Please try again.");
            });
    };
    return (
        <>
            {error && <MessageBar messageBarType={MessageBarType.error}>{error}</MessageBar>}
            <DefaultButton
                text="Sign in"
                onClick={handleSignIn}
                disabled={disabled}
            />
        </>
    );
};
